module.exports = __webpack_public_path__ + "img/character2.4d0d1e32.png";